'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RouterActions = require('../../../core/actions/RouterActions');

var _appStepRoutes = require('../../../core/constants/appStepRoutes');

var _appStepRoutes2 = _interopRequireDefault(_appStepRoutes);

var _DetectAuth = require('../../../core/routeHandlers/DetectAuth/DetectAuth');

var _DetectAuth2 = _interopRequireDefault(_DetectAuth);

var _Auth = require('../../../core/utils/Auth');

var _Auth2 = _interopRequireDefault(_Auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var detectAuthStep = function detectAuthStep() {
  var notAuthRoute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _appStepRoutes2.default.JOIN_HUBSPOT_ACCOUNT;
  var authHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Auth2.default;
  var authRoute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _appStepRoutes2.default.EXISTING_USER;
  var authRouteNoPortal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _appStepRoutes2.default.DOMAIN;
  var route = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _appStepRoutes2.default.DETECT_AUTH;

  return {
    route: route,
    handler: _DetectAuth2.default,
    props: {
      AuthHandler: authHandler,
      handleAuthed: _RouterActions.goToStep.bind(null, authRoute),
      handleAuthedNoPortal: _RouterActions.goToStep.bind(null, authRouteNoPortal),
      handleNotAuthed: _RouterActions.goToStep.bind(null, notAuthRoute)
    }
  };
};

exports.default = detectAuthStep;
module.exports = exports['default'];